export default __webpack_public_path__ + "media/images/qr/medium_business_line-864e0f6a57da48992b4e83e4cb65355a.png";